// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { X, Info, AlertTriangle, CheckCircle } from 'lucide-react';
import { classNames } from '../utils/helpers';

const CONFIG = {
  info: {
    icon: Info,
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
  },
  success: {
    icon: CheckCircle,
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-800',
  },
  warning: {
    icon: AlertTriangle,
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-800',
  },
  error: {
    icon: AlertTriangle,
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-800',
  },
};

export function Banner({ message, type = 'info', onDismiss }) {
  const cfg = CONFIG[type] ?? CONFIG.info;
  const Icon = cfg.icon;

  return (
    <div
      className={classNames(
        'flex items-center gap-3 px-4 py-3 rounded-xl border text-sm',
        cfg.bg,
        cfg.border,
        cfg.text,
      )}
    >
      <Icon size={16} className="shrink-0" />
      <span className="flex-1">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="opacity-60 hover:opacity-100 ml-2"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}

export default Banner;
